import React from 'react';
import styles from './index.module.scss';

const ContentMissing = () => {
  return (
    <main className={styles.container}>
      <div className={styles.box}>
        <img
          src="https://img.buzzfeed.com/store-an-image-prod-us-east-1/Crms_wLoj.png"
          alt="Content no longer available"
          className={styles.image}
        />
        <h1 className={styles.title}>No longer available</h1>
        <p className={styles.subtitle}>Seems like this generator was deleted</p>
      </div>
    </main>
  );
};

export default ContentMissing;
